
import React from 'react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

const WindowSwitch = ({appActions, iconName, title, windowName}) => {

    const handleClick = () => {
        appActions.setUiValue('activeWindow', windowName);
    }

    return (
        <CommandButton 
            iconProps={{
                iconName: iconName,
                styles: {
                    root: {
                        fontSize: 24
                    }
                }
            }} 
            title={title}
            onClick={handleClick}
        />
    );
}

const WindowSwitcher = ({activeWindow, appActions, windowList}) => {

    const classNames = mergeStyleSets({
        WindowSwitcher: {            
        }
    });

    return (
        <Stack className={classNames.WindowSwitcher}>
            {windowList
                .filter(item => item.windowName !== activeWindow)
                .map(item => {
                    return (
                        <WindowSwitch 
                            key={item.windowName}
                            appActions={appActions} 
                            {...item} 
                        />
                    );
            })}
        </Stack>
    );
};

export default WindowSwitcher;
